/**
 * @module Shop
 * @copyright 1994-2017 T-Mobile US, Inc. All Rights Reserved.
 */ /** */
// Core Libraries
import { Injectable } from '@angular/core';

import { Observable, Subject } from 'rxjs';
// @TODO DELETE THIS SERVICE
/**
 * Route guard checks if cart token has been generated, if not requests for token
 */
@Injectable({
  providedIn: 'root',
})
export class CartTokenGuardService {
  /**
   * Observable to track if token was generated and cartId was set
   */
  public tokenGenerated$: Observable<boolean>;
  /**
   * Subject declaration - will be cast as observable, allows multiple subscribers
   */
  private tokenGeneratedSource: Subject<boolean>;

  constructor() {
    this.tokenGeneratedSource = new Subject();
    this.tokenGenerated$ = this.tokenGeneratedSource.asObservable();
  }

  /**
   * Can Activate guard checks to make sure token/cartId is set
   */
  public canActivate(): boolean {
    return true;
  }
}
